import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const getPastWeekDates = () => {
  let dates = "0123456".split("").map((day) => {
    let tempDate = new Date();
    tempDate.setDate(tempDate.getDate() - day);
    return tempDate.toLocaleDateString("en-US");
  });
  return dates.reverse();
};

const ProductivityGraph = ({ numberOfStep, membersStepDone, isTeam }) => {
  let data;
  let datasets;

  console.log(
    "numberOfStep : ",
    numberOfStep,
    "memberStepDone : ",
    membersStepDone,
    "isTeam : ",
    isTeam
  );

  if (isTeam) {
    const colors = [
      "rgb(75, 192, 192)",
      "rgb(192, 75, 75)",
      "rgb(192, 192, 75)",
      "rgb(75, 75, 192)",
      "rgb(75, 192, 75)",
      "rgb(192, 75, 192)",
      "rgb(75, 192, 75)",
    ];
    console.log("membersStepDone : ", membersStepDone);

    datasets = membersStepDone.map((member, index) => {
      return {
        label: `Étapes complétées par ${member.username}`,
        data: member.nbreStepsDone,
        fill: false,
        backgroundColor: colors[index % colors.length],
        borderColor: colors[index % colors.length],
      };
    });

    data = {
      labels: getPastWeekDates(),
      datasets: datasets,
    };
  } else {
    console.log("step done :", membersStepDone);
    while (numberOfStep.length < 7) {
      numberOfStep.unshift(0);
    }
    data = {
      labels: getPastWeekDates(),
      datasets: [
        {
          label: "Étapes completées",
          data: numberOfStep,
          fill: false,
          backgroundColor: "rgb(75, 192, 192)",
          borderColor: "rgba(75, 192, 192)",
        },
      ],
    };
  }

  var options = {
    scales: {
      x: {
        grid: {
          display: false, // Cela cache la grille de l'axe des x
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: true, // Cela cache la grille de l'axe des y
        },
        ticks: {
          stepSize: 1, // N'affiche que des nombres entiers
        },
      },
    },
    legend: {
      labels: {
        fontSize: 25,
      },
    },
  };

  return <Line data={data} options={options} className="productivityGraph" />;
};

export default ProductivityGraph;
